import { c as _c } from "react/compiler-runtime";
// "use client";

import { ExternalLink } from "lucide-react";
import { format } from "date-fns";
import Image from "next/image";
import Link from "next/link";
import { Text } from "../ui/text";
import { Card, CardContent, CardFooter } from "../ui/card";
import { Badge } from "../ui/badge";
type MediaCardProps = {
  headline: string;
  mediaUrl: string;
  readingTime: string;
  logo: string;
  description: string;
  publishAt: string;
  mediaHouseName?: string;
};
export const MediaCard = props => {
  const $ = _c(32);
  const {
    mediaUrl,
    readingTime,
    logo,
    description,
    publishAt,
    headline,
    mediaHouseName
  } = props;
  let publishAtDate;
  try {
    let t0;
    if ($[0] !== publishAt) {
      t0 = format(new Date(publishAt), "dd MMM yyyy");
      $[0] = publishAt;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    publishAtDate = t0;
  } catch {
    publishAtDate = publishAt;
  }
  let t0;
  if ($[2] !== headline || $[3] !== logo || $[4] !== mediaHouseName) {
    t0 = <div className="relative flex h-7 w-28 flex-1 shrink-0 items-center">{logo ? <Image src={logo} alt={mediaHouseName || headline} fill={true} sizes="112px" className="object-contain object-left brightness-95 contrast-125" style={{
        filter: "drop-shadow(0px 1px 3px rgba(15, 23, 42, 0.18))"
      }} /> : <span className="text-xs leading-none font-black tracking-widest text-slate-600 uppercase">{mediaHouseName || "News Media"}</span>}</div>;
    $[2] = headline;
    $[3] = logo;
    $[4] = mediaHouseName;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="group-hover:text-primary-main group-hover:bg-primary-main/5 border-border bg-background text-muted-foreground flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-all duration-300"><ExternalLink size={13} className="stroke-[2.5]" /></div>;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t0) {
    t2 = <div className="border-border mb-4 flex items-center justify-between gap-4 border-b pb-3.5">{t0}{t1}</div>;
    $[7] = t0;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== headline) {
    t4 = <Text render={t3} className="group-hover:text-primary-main mb-2.5 line-clamp-2 text-sm leading-snug font-extrabold tracking-tight transition-colors duration-200 sm:text-base">{headline}</Text>;
    $[10] = headline;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== description) {
    t5 = <Text className="text-muted-foreground mb-5 line-clamp-3 text-xs leading-relaxed font-medium sm:text-sm">{description}</Text>;
    $[12] = description;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t4 || $[16] !== t5) {
    t6 = <CardContent>{t2}{t4}{t5}</CardContent>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span>Published</span>;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== publishAtDate) {
    t8 = <div className="flex items-center gap-1">{t7}<span className="text-muted-foreground font-extrabold">{publishAtDate}</span></div>;
    $[19] = publishAtDate;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== readingTime) {
    t9 = readingTime && <Badge variant="outline">{readingTime} Read</Badge>;
    $[21] = readingTime;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <CardFooter className="bg-card flex items-center justify-between text-[10px] font-bold tracking-wider uppercase">{t8}{t9}</CardFooter>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t6) {
    t11 = <Card className="group flex h-full flex-col justify-between shadow-[0_8px_30px_rgba(15,23,42,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(15,23,42,0.1)]">{t6}{t10}</Card>;
    $[26] = t10;
    $[27] = t6;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== mediaUrl || $[30] !== t11) {
    t12 = <Link href={mediaUrl} target="_blank" rel="nofollow" className="block h-full">{t11}</Link>;
    $[29] = mediaUrl;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};